import TablaConciliacion from "../../../TablaConciliacion";

function TablaRutaMSierraMar() {
  return <TablaConciliacion nombreUseCase="RUTAMSIERRAMAR" titulo="RUTA M SIERRA MAR" />;
}

export default TablaRutaMSierraMar;
